<div class="row">

    <div class="col-12 my-2" *ngIf="message!=''">
        <div class="alert border-info text-info text-center">
            <i class="fas fa-info-circle mr-2"></i>{{message}}
        </div>
    </div>

    <ng-container *ngIf="csv.length == 0">
        <div class="col-lg-9">           
                <div class="m-auto w-100 text-center p-2" style="max-width: 600px; height:200px; color:#ccc; border: 1px dashed #ccc; border-radius:10px">
                    <i class="fas fa-2x fa-bullseye mt-5 animation__wobble"></i><br>
                    <i>Trascina e rilascia <b>qui</b> il file CSV da importare.</i><br>
                    <a class="btn btn-secondary btn-sm mt-4" (click)="onChange($event)"><i class="fas fa-upload mr-2"></i>Scegli...</a>
                </div>
                <input class="d-block w-100 pointer" type="file" style="max-width: 600px; height:200px; margin:-200px auto 0; opacity:0;" #fileToUpload name="fileToUpload" (change)="onChange($event)">
            <div class="row">
                <div class="col-12 col-lg-4"></div>
                <div class="col-12 col-lg-4 mt-2">
                    <label>Carattere separatore</label>
                    <input type="text" size="1" class="form-control form-control-sm" [(ngModel)]="separator">
                </div>
            </div>           
       </div>
        <div class="col-lg-3 border-left text-xs">
            <h6>Attenzione</h6>
            <p>
            Per importare correttamente il file CSV, è necessario che:<br>
            - sia stato impostato il <b>carattere separatore</b> corretto (di solito la virgola o il punto e virgola)<br>
            - le colonne <b>Nominativo</b> e <b>Data</b> siano sempre valorizzati (no NULL)<br>
            - le date siano nel formato ISO (<b>YYYY-MM-DD</b>)<br>
            - nei valori non ci siano caratteri come: <b>¶</b> (a capo) <b>"</b> (virgolette) <b>'</b> (apici) <b>{{separator}}</b> (carattere separatore)<br>
            </p>
        </div>
    </ng-container>

    <ng-container *ngIf="csv.length > 0">        
        <div class="col-12">
            <div class="table-responsive" style="max-height: 300px; overflow: auto;">
                <table class="table table-sm table-bordered table-hover">
                    <thead>
                        <th></th>
                        <th *ngFor="let col of headers">
                            {{col.name}}
                        </th>
                    </thead>
                    <thead>
                        <th></th>
                        <th *ngFor="let h of headers;let j=index">
                            <select class="form-control form-control-sm" [(ngModel)]="h.field">
                                <option [ngValue]="null"></option>
                                <option *ngFor="let f of fields" [ngValue]="f">{{f.label}}</option>
                            </select>
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of csv;let i=index">
                            <td class="text-gray text-xs text-center" title="numero di riga">{{i+1}}</td>
                            <td *ngFor="let c of r;let j=index" title="{{headers[j].name}}">{{c}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="my-3">
                <input type="checkbox" [(ngModel)]="truncateTable">&nbsp;<small>Svuota la tabella prima di procedere all'importazione</small>
            </div>
            <button class="btn btn-outline-secondary mr-2" (click)="reset()"><i class="fa fa-chevron-left mr-2"></i>Scegli un'altro file</button>
            <button class="btn btn-outline-primary" (click)="startImport()">Avvia l'importazione</button>
        </div>
    </ng-container>
</div>